<template>
  <BaseSelect v-model="currentlySelectedOption" :options="selectDateColumnOperators" :append-to-body="true"></BaseSelect>
  <template v-if="dateFilter.option === DateColumnOperators.BETWEEN">
    <BaseInput v-model="betweenStartInput" :type="dateTimeInputOption"> </BaseInput>
    <BaseInput v-model="betweenEndInput" :type="dateTimeInputOption"> </BaseInput>
  </template>
  <BaseInput v-if="dateFilter.option === DateColumnOperators.BEFORE" v-model="singleValueInput" :type="dateTimeInputOption">
  </BaseInput>
  <BaseInput v-if="dateFilter.option === DateColumnOperators.AFTER" v-model="singleValueInput" :type="dateTimeInputOption">
  </BaseInput>
  <BaseInput v-if="dateFilter.option === DateColumnOperators.EXACT" v-model="singleValueInput" :type="dateTimeInputOption">
  </BaseInput>
  <ValueExistsFilter v-if="dateFilter.option === CommonColumnOperators.VALUE_EXISTS" v-model="dateFilter"></ValueExistsFilter>
</template>

<script setup lang="ts">
import { computed, ref } from "vue";
import { useI18n } from "vue-i18n";
import BaseInput from "../../../../components/BaseInput.vue";
import BaseSelect from "../../../../components/BaseSelect.vue";
import { isNullOrWhitespace } from "../../../../util/isNullOrWhitespace";
import { CommonColumnOperators, DateColumnOperators } from "../../enum.filterOperators";
import { GenericTableSchemaFormat } from "../../enum.genericTableSchemaFormat";
import { DateFilterType } from "../../type.genericTableQuery";
import ValueExistsFilter from "./ValueExistsFilter.vue";
const { t } = useI18n();
const dateFilterType = defineModel<DateFilterType>({ required: true });
const dateFilter = computed(() => dateFilterType.value.filter);

const props = defineProps<{ format: GenericTableSchemaFormat.DATE | GenericTableSchemaFormat.DATE_TIME }>();
const dateTimeInputOption = props.format === GenericTableSchemaFormat.DATE ? "date" : "datetime-local";
const tempBetweenStart = ref("");
const tempBetweenEnd = ref("");

const selectDateColumnOperators = [
  { value: DateColumnOperators.BETWEEN, label: t("genericTable.dateFilter.between") },
  { value: DateColumnOperators.BEFORE, label: t("genericTable.dateFilter.before") },
  { value: DateColumnOperators.AFTER, label: t("genericTable.dateFilter.after") },
  { value: DateColumnOperators.EXACT, label: t("genericTable.dateFilter.exact") },
  { value: CommonColumnOperators.VALUE_EXISTS, label: t("genericTable.valueExistsFilter.valueExists") },
];

const currentlySelectedOption = computed({
  get() {
    return dateFilter.value.option;
  },
  set(newOption) {
    if (newOption !== dateFilter.value.option) {
      dateFilter.value.value = undefined;
      dateFilter.value.option = newOption;
    }
  },
});

const singleValueInput = computed({
  get: () => (typeof dateFilter.value.value === "string" ? dateFilter.value.value : ""),
  set: (val: string) => {
    dateFilter.value.value = val === "" ? undefined : val;
  },
});

const betweenStartInput = computed({
  get: () => tempBetweenStart.value,
  set: (val) => {
    tempBetweenStart.value = val;
    updateBetween();
  },
});

const betweenEndInput = computed({
  get: () => tempBetweenEnd.value,
  set: (val) => {
    tempBetweenEnd.value = val;
    updateBetween();
  },
});

function updateBetween() {
  if (!isNullOrWhitespace(tempBetweenStart.value) && !isNullOrWhitespace(tempBetweenEnd.value)) {
    dateFilter.value.value = [tempBetweenStart.value, tempBetweenEnd.value];
  } else {
    dateFilter.value.value = undefined;
  }
}
</script>
